<script lang="ts">
    import type {HierarchyTree, RecordHierarchyTreeNode, HierarchyTreeNode, UUID} from '../../typings/portaro.be.types';
    import type {LocalizeFunction} from '../../svelte/types';
    import {getContext} from 'svelte';
    import {CONTEXT_PATH_KEY, LOCALIZE_KEY} from '../../svelte/utils';
    import KpGenericHierarchyTreesView from '../../commons/components/kp-generic-hierarchy-trees-view/KpGenericHierarchyTreesView.svelte';
    import {fade} from 'svelte/transition';

    export let hierarchyTrees: HierarchyTree<UUID, RecordHierarchyTreeNode>[];

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const CONTEXT_PATH: string = getContext(CONTEXT_PATH_KEY);

    function recastToRecordTreeNode(node: HierarchyTreeNode<UUID | number | string>): RecordHierarchyTreeNode {
        return node as RecordHierarchyTreeNode;
    }
</script>

<template>
    {#if hierarchyTrees.length > 0 && hierarchyTrees[0].nodes.length > 1}
        <div class="vystouplyDiv record-hierarchy-panel" transition:fade={{duration:200}}>
            <KpGenericHierarchyTreesView hierarchyTrees={hierarchyTrees} let:node>
                <!-- if the next line is red then IDEA/Svelte plugin still do not support new features (ignore it) -->
                {@const recordTreeNode = recastToRecordTreeNode(node)}
                {#if recordTreeNode.current}
                    <strong>{recordTreeNode.text}</strong>
                {:else if recordTreeNode.see}
                    {localize(/* @kp-localization commons.viz */ 'commons.viz')}: {recordTreeNode.text}
                {:else }
                    {#if recordTreeNode.seeAlso}
                        {localize(/* @kp-localization commons.vizTez */ 'commons.vizTez')}:
                    {/if}
                    <a href="{CONTEXT_PATH}/records/{recordTreeNode.id}">{recordTreeNode.text}</a>
                {/if}
            </KpGenericHierarchyTreesView>
        </div>
    {/if}
</template>

<style lang="less">
  .record-hierarchy-panel {
    margin-top: 10px;
    padding: 10px;
  }
</style>